export const BOUND_BOX = {
    USA_BOUNDS: {
        LAT: [-124.541016, -74.003906],
        LONG: [25.403585, 49.009051]
    }
}
// export default BOUND_BOX;